export const validateFields = (fields, errorCallback) => {
  const requiredFields = [
    { key: "name", label: "Название" },
    // { key: "responseDelay", label: "Задержка ответа" },
    // { key: "firstName", label: "Имя" },
    { key: "settings.instruction", label: "Инструкции" },
    // { key: "companyDescription", label: "Описание компании" },
  ];

  for (const field of requiredFields) {
    const keys = field.key.split(".");
    let value = fields;

    for (const key of keys) {
      if (!value || typeof value !== "object") {
        value = null;
        break;
      }
      value = value[key];
    }

    if (
      (!value || String(value).trim() === "") &&
      field.key === "settings.instruction"
    ) {
      const numericValue = Number(value);
      if (isNaN(numericValue) || numericValue < 1) {
        errorCallback(
          `Поле "${field.label}" не заполнено! \n Выберите шаблон или перейдите в расширенные настройки.`
        );
        return false;
      }
    }

    if (!value || String(value).trim() === "") {
      errorCallback(`Поле "${field.label}" не заполнено!`);
      return false;
    }

    // Проверка минимального значения для responseDelay
    if (field.key === "responseDelay") {
      const numericValue = Number(value);
      if (isNaN(numericValue) || numericValue < 15) {
        errorCallback(`Поле "${field.label}" должно быть не меньше 15!`);
        return false;
      }
    }
  }

  return true;
};

export const validateFieldsTgBot = (fields, errorCallback) => {
  const requiredFields = [
    { key: "name", label: "Название" },
    { key: "token", label: "Токен" },
    // { key: "description", label: "Описание" },
    // { key: "about", label: "Короткое описание" },
    // { key: "helloMessage", label: "Приветственное сообщение" },
  ];

  const errors = [];

  // Проверяем обязательные текстовые поля
  for (const field of requiredFields) {
    const value = fields?.[field.key];

    if (!value || String(value).trim() === "") {
      errors.push(`Поле "${field.label}" не заполнено!`);
    }
  }

  // Проверяем формат токена
  const TELEGRAM_TOKEN_REGEX = /^\d{9,10}:[A-Za-z0-9_-]{35}$/;
  if (fields?.token && !TELEGRAM_TOKEN_REGEX.test(fields.token)) {
    errors.push(
      "Токен бота недействителен. Убедитесь, что он соответствует формату Telegram."
    );
  }

  // Проверяем, выбран ли ассистент
  if (
    !fields?.assistantId ||
    fields.assistantId === "" ||
    fields.assistantId === null
  ) {
    errors.push("Выберите ассистента");
  }

  if (errors.length > 0) {
    errorCallback(errors);
    return false;
  }

  return true;
};

export const validateWidgetFields = (fields, errorCallback) => {
  const requiredFields = [
    { key: "name", label: "Название виджета" },
    { key: "header", label: "Заголовок виджета" },
    { key: "assistantName", label: "Имя ассистента" },
    { key: "allowedDomains", label: "Доверенные домены" },
  ];

  const errors = [];

  // Проверяем обязательные текстовые поля
  for (const field of requiredFields) {
    const value = fields?.[field.key];

    if (!value || String(value).trim() === "") {
      errors.push(`Поле "${field.label}" не заполнено!`);
    }
  }

  // Проверяем, выбран ли ассистент
  if (
    !fields?.assistantId ||
    fields.assistantId === "" ||
    fields.assistantId === null
  ) {
    errors.push("Выберите ассистента");
  }

  if (errors.length > 0) {
    errorCallback(errors);
    return false;
  }

  return true;
};

export const validateDialogFWFields = (fields, errorCallback) => {
  const requiredFields = [
    { key: "assistantName", label: "Имя ассистента" },
    { key: "allowedDomains", label: "Доверенные домены" },
  ];

  const errors = [];

  // Проверяем обязательные текстовые поля
  for (const field of requiredFields) {
    const value = fields?.[field.key];

    if (!value || String(value).trim() === "") {
      errors.push(`Поле "${field.label}" не заполнено!`);
    }
  }

  // Проверяем, выбран ли ассистент
  if (
    !fields?.assistantId ||
    fields.assistantId === "" ||
    fields.assistantId === null
  ) {
    errors.push("Выберите ассистента");
  }

  if (errors.length > 0) {
    errorCallback(errors);
    return false;
  }

  return true;
};
